import {
  HOME_HIGHLIGHTS_UPLOAD_REQUEST,
  HOME_HIGHLIGHTS_UPLOAD_SUCCESS,
  HOME_HIGHLIGHTS_UPLOAD_FAIL,
  HOME_HIGHLIGHTS_FETCH_REQUEST,
  HOME_HIGHLIGHTS_FETCH_SUCCESS,
  HOME_HIGHLIGHTS_FETCH_FAIL,
  HOME_HIGHLIGHTS_DELETE_REQUEST,
  HOME_HIGHLIGHTS_DELETE_SUCCESS,
  HOME_HIGHLIGHTS_DELETE_FAIL,
} from "../../constants/admin/homeHighlightsConstants";

const initialState = {
  loading: false,
  success: false,
  error: null,
  homeHighlights: [],
  message: null,
};

// 🔹 Single Reducer for home highlights actions
export const homeHighlightsReducer = (state = initialState, action) => {
  switch (action.type) {
      case HOME_HIGHLIGHTS_UPLOAD_REQUEST:
      case HOME_HIGHLIGHTS_FETCH_REQUEST:
      case HOME_HIGHLIGHTS_DELETE_REQUEST:
          return { ...state, loading: true, success: false, error: null };

      case HOME_HIGHLIGHTS_UPLOAD_SUCCESS:
          return { ...state, loading: false, success: true, homeHighlights: action.payload.homeHighlights };

      case HOME_HIGHLIGHTS_FETCH_SUCCESS:
          return { ...state, loading: false, homeHighlights: action.payload };

      case HOME_HIGHLIGHTS_DELETE_SUCCESS:
          return { ...state, loading: false, success: true, message: action.payload.message };

      case HOME_HIGHLIGHTS_UPLOAD_FAIL:
      case HOME_HIGHLIGHTS_FETCH_FAIL:
      case HOME_HIGHLIGHTS_DELETE_FAIL:
          return { ...state, loading: false, error: action.payload };

      default:
          return state;
  }
};
